export default "__VITE_ASSET__a5702786__"